import ApiService from "../../services/ApiService";
import ValidationService from "../../services/ValidationService";
import { executeReCaptcha } from "../../helper/executeReCaptcha";
import { exceptionMap } from "../../exceptions/ExceptionMap";

$(document).on('click','.clickable-title',function(){
    $(this).closest('.clickable-cat-left').toggleClass('is-open');
})
$(document).on('click','.open-search',function(){
    $('.main-search').toggleClass('is-open');
    //$(".search-input").focus();
    //$(".search-input").focus();

    setTimeout(function(){
        if($('.main-search').hasClass('is-open')){
            $(".search-input").focus();
        }
        
    }, 300);
})
$(document).on('click','.btn-accordion',function(){
    $(this).closest('.tab-pane').toggleClass('active');
})
$(document).on('click','.wish-list-link',function(){
    document.location = $(this).data('href');
})



$(document).on('change','.quantity-input-select',function(){
    
    $('.single .qty-input').val($(this).val());
    $('.single .qty-input')[0].dispatchEvent(new Event("change"))
})

$(document).on('click','.b2b-login-switch-register',function(){
    $('.b2b-wrap').toggleClass('show-b2b-register');
})
$(document).on('click','.link-right-modal-b2b',function(){
    $($(this).attr('href')).modal('show');
})
$(document).on('click','.show-b2b-register .form-check-label a[href="/datenschutzerklaerung/"]',function(){
    $('#policyrights').modal('show');
    return false;
})


$(document).on('click', 'a[href="#privacy-settings"]', function() {
    $('.cookie-bar').removeClass('out');
    return false;
});

$(document).on('click', ".facet-fake-select", function() {
    $(this).closest('.cat-facet-group').toggleClass('is-open');
    return false;
});
$(document).mouseup(function(e) 
{
    var container = $(".cat-facet-group.is-open");
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        //console.log($(container).hasClass('cat-facet'))
        //if(!$(container).hasClass('cat-facet'))
        container.removeClass('is-open');
    }
});

var timeoutHandle;
$(document).on("mouseenter",".mainmenu > .ddown", function () {
    if($(window).width() >= 1200){
        var _this = this;
        timeoutHandle = setTimeout(function(){ 
             $(_this).addClass('isHover');
         }, 300); 
    }
    
});
$(document).on("mouseleave",".mainmenu > .ddown", function () {
    if($(window).width() >= 1200){
        var _this = this;
        clearTimeout(timeoutHandle);
        //setTimeout(function(){ 
            $(_this).removeClass('isHover');
        //}, 300);
    }
});
/*
$(document).on("click",".list-prev-images-splide a", function () {
    console.log("dxirnne")
    if($(this).attr('href').indexOf('-1.png') === -1){
        
        $('.item-img-gallery').addClass('full-size-image');
    }else{
        $('.item-img-gallery').removeClass('full-size-image');
    }
});*/



$(document).on("change",".cross-sell-select", function () {
    document.location.href = $(this).find(":checked").val();
});
$(document).on("click",".btn-toggle-filter, .filter-backdrop", function () {
    $('body').toggleClass('open-filter');
});

document.addEventListener('doofinder.cart.add', function(event) {
    const data = {
        variationId : parseInt(event.detail.item_id),
        quantity    : 1,
        totalOrderParamsMarkup: 0,
        template: 'Ceres::Basket.Basket',
        templateType: 'item'
    };
    vueApp.$store.commit("setIsAddToBasketLoading", data.variationId);
    vueApp.$store.dispatch('loadComponent', 'basket-preview');
    
    vueApp.$store.dispatch("addBasketItem", data).then(
        response =>
        {
            document.dispatchEvent(new CustomEvent("afterBasketItemAdded", { detail: data }));
            vueApp.$store.commit("setIsAddToBasketLoading", 0);
        },
        error =>
        {
            vueApp.$store.commit("setIsAddToBasketLoading", 0);
            if (error.data)
            {
                if(exceptionMap.has(error.data.exceptionCode.toString())){
                    NotificationService.error(
                        vueApp.$translate(
                            "Ceres::Template." + exceptionMap.get(error.data.exceptionCode.toString()),
                            error.data.placeholder
                        )
                    ).closeAfter(5000);
                }else{
                    NotificationService.error(
                        vueApp.$translate("Es ist ein Fehler aufgetreten.")
                    ).closeAfter(5000);
                }

                
            }
        });
});

$(document).on( "submit",".b2b-registration-form", function( event ) {

    

    var form = this;
  event.preventDefault();
  ValidationService.validate($('.b2b-registration-form')[0]).done(() =>
    {
        const deferred = $.Deferred();   
        executeReCaptcha(vueApp.$refs.b2bregistration.$refs.registrationForm)
                .then((recaptchaToken) =>
                {  
       // window.grecaptcha.execute(App.config.global.googleRecaptchaApiKey,
         //   { action: "homepage" }
       // ).then(response =>
        //{
            //if (response)
            //{
                if (!App.config.global.registrationRequirePrivacyPolicyConfirmation || vueApp.$refs.b2bregistration.privacyPolicyAccepted)
                {
                    vueApp.$refs.b2bregistration.privacyPolicyShowError = false;
                    const userObject = vueApp.$refs.b2bregistration.getUserObject();
                    userObject.recaptcha = recaptchaToken;
                    userObject.username = $('.b2b-registration-form [data-testing="mail-register"]').val();
                    
                    const vatData = {
                        vatNumber : userObject.billingAddress.vatNumber
                    }
                    $('.btn-submit-b2b-registration i').attr('class', 'fa default-float fa fa-spin fa-circle-o-notch');
                    registerCustomer(userObject);
                    /*
                    ApiService.get("/rest/vatcheck/", vatData).done(response =>
                    {
                        var dataParsed = JSON.parse(response);

        
                        const newsletterData = {
                            email : userObject.username,
                            firstName: '',
                            lastName: '',
                            emailFolder: 2,
                            templateEvent: 'tpl.home',
                            recaptcha: recaptchaToken,
                            honeypot: ''
                        }
                        
                        if(dataParsed.data.valid){
                            /*if ($('#nlregistration').is(":checked")){
                                ApiService.post("/rest/io/customer/newsletter/", newsletterData)
                                .done(response =>
                                {
                                    registerCustomer(userObject);
                                })
                            }else{
                                
                            }
                            
                        }else{
                            window.CeresNotification.error("Die eingegebene Umsatzsteuer-Identifikationsnummer ist ungültig.").closeAfter(10000);
                            $('.btn-submit-b2b-registration i').attr('class', 'fa default-float fa-user-plus');
                        }       
    
                        
                    })
                    .fail((error) =>
                    {
                        window.CeresNotification.error("Es ist ein Fehler aufgetreten.").closeAfter(10000);
                        //window.CeresNotification.error(error.error).closeAfter(10000);

                    });*/
                }
                else
                {
                    vueApp.$refs.b2bregistration.privacyPolicyShowError = true;
                    window.CeresNotification.error(vueApp.$translate("Ceres::Template.contactAcceptFormPrivacyPolicy", { hyphen: "&shy;" })).closeAfter(10000);
                    window.grecaptcha.reset()
                }
                
            //}
        });
    })
    .fail(invalidFields =>
    {
       //vueApp.$refs.invoiceAddressSelect.$refs.invoice.$refs.updateadress.validate();
       ValidationService.markInvalidFields(invalidFields, "error");
        const fieldNames = [];
        for (const field of invalidFields)
        {
            let fieldName = field.lastElementChild.innerHTML.trim();

            fieldName = fieldName.slice(-1) === "*" ? fieldName.slice(0, fieldName.length - 1) : fieldName;
            fieldNames.push(fieldName);
        }
        window.CeresNotification.error(
            vueApp.$translate("Ceres::Template.checkoutCheckAddressFormFields", { fields: fieldNames.join(", ") })
        );
    });
    return false;
});

function registerCustomer(userObject){
    ApiService.post("/rest/io/customer/", userObject)
    .done(response =>
    {

        ApiService.setToken(response);
        userObject.customerid = response.id;

        if (!response.code)
        {
            document.dispatchEvent(new CustomEvent("onSignUpSuccess", { detail: userObject }));
            $('.btn-submit-b2b-registration i').attr('class', 'fa default-float fa-user-plus');
        }
        else
        {
            window.CeresNotification.error(
                vueApp.$translate("Ceres::Template.regError")
            ).closeAfter(10000);
        }
        window.location.reload();
    })
    .fail((error) =>
    {
        $('.btn-submit-b2b-registration i').attr('class', 'fa default-float fa-user-plus');
        window.CeresNotification.error(error.error).closeAfter(10000);

    });
}

$(document).on('click','.link-gallery-video',function(){
    var videoSrc = $(this).attr('href');
    var videoHtml =  '<video controls>';
    videoHtml += `<source src="${videoSrc}" type="video/mp4">`;
    videoHtml += 'Your browser does not support the video tag.';
    videoHtml += '</video>';
  
    $('.modal-video').find('.modal-body').html(videoHtml);
    $('.modal-video').modal();
    return false;
})
$('.modal-video').on('hidden.bs.modal', function () {
    $('.modal-video').find('.modal-body').html('');
})
if($('.modal-aktion').length>0){
    $(window).scroll(function(){
        if($(window).scrollTop()>800){
            if(getCookie('showModalAktion')==null){
                $('.modal-aktion').modal();
                setCookie('showModalAktion','false',1) 
            }
        }
    });
}
$(document).on('click','.btn-close-header-offer',function(){
    setCookie('hideHeaderOffer','false',1);
    $('.top-header-offer').hide();
    return false;
})
function getVariationProperties(){
    if($('.result-container-naehwert').length > 0){
        let variationIdArray = $('.result-container-naehwert').data('variationsid');
        let variationParam = {
            variationIds: variationIdArray
        }
    ///rest/getVariationProperties/?variationIds[]=2887&variationIds[]=2848
        ApiService.get("/rest/getVariationProperties/", variationParam).done(response =>
        {
            //console.log(response.templateNaewert)
            $('.result-container-naehwert').html(response.templateNaewert);
            $('.result-container-zutaten').html(response.templateZutatenUndAlergene);
        })
        .fail((error) =>
        {
            window.CeresNotification.error("Es ist ein Fehler aufgetreten.").closeAfter(10000);

        });
    }
}
$(document).ready(function(){
    getVariationProperties();
    if($('.btn-close-header-offer').length > 0){
        if(getCookie('hideHeaderOffer') != null){
            $('.top-header-offer').hide();
        }
    }
    
})